"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formEvents = exports.inputEvents = void 0;
exports.inputEvents = {
    changed: 'input:changed',
    change: 'change' // Standard change event for broader compatibility
};
exports.formEvents = {
    submit: 'form:submit'
};
